module.exports = __webpack_public_path__ + "img/patent_18.c2c6048.jpg";